<!--
*@description：上传红线
*@author:rzl
*@date:2021/5/24 13:45
-->
<template>
<a-modal v-model:visible="visible"
         :maskClosable="false"
         :title="modalTitle"  width="55%"
         :destroyOnClose="true"
>

  <div class="ant-row">
    <div class="ant-col-14">
        <map_info ref="mapInfo" />
    </div>
    <div class="ant-col-10">
      <a-form-item  >
        <div style="margin-top: 20%;margin-right: 40%">
          <a-upload
              v-model:file-list="fileList"
              name="file"
              :data='parms'
              :action="actionUrl"
              @change="handleChange"
              :showUploadList="false"
              :accept="accept"
              withCredentials
          >
            <a-button style="background-color: #096dd9;color: #fafafa;">
              <upload-outlined></upload-outlined>
              上传成果红线
            </a-button>
          </a-upload>
        </div>
      </a-form-item>
    </div>
  </div>

  <template #footer>
    <a-button key="back" @click="visible =false">取消</a-button>
  </template>
</a-modal>
</template>

<script>
import Icons from "../../../common/Icons";
import achieveGeom_api from "../config/achieveGeom_api";
import map_info from "../common/point/map_info";
import achieveRecord_api from "../config/achieveRecord_api";

export default {
name: "sc_hx",
mixins:[Icons],
components:{
  map_info
},
data(){
    return{
      /**弹框文件信息**/
      visible:false,
      modalTitle:null,

      accept:".zip",//Vimage/png,image/jpeg
      file:null,
      fileList:[],
      previewVisible:false,
      actionUrl:achieveGeom_api.saveOrUpd.url,
      baseImageUrl:"d:",
      spinning:false,

      parms:{
        id:null,
        achieveId:null,
      },
      formData:null,

    }
},
methods:{
  /***
   * 打开文件编辑
   */
  openFile(cgid,geomList){
    let geom = geomList.length > 0 ? geomList[0].geom : null;
    let geomId = geomList.length > 0 ? geomList[0].id : null;
    this.parms.achieveId = cgid;
    this.parms.id = geomId;
    this.visible = true;
    this.modalTitle = '成果红线信息';
    setTimeout(()=>{
      this.$refs.mapInfo.initMap(geom);
    },200);
  },
  handleChange({file,fileList,event}){
    if(file.status === "uploading"){ //status: "uploading"
      this.spinning = true;
    }
    else if(file.status==="done"){//status: "done"
      let flag = file.response.flag
      if(flag){
        this.spinning = false;
        this.$message.success(file.response.msg);
        //this.visible = false;
        this.findInfo();
        this.$emit("event",this.$GetEmitData(this.$eventTags.refresh));
      }else{
        this.$message.error(file.response.msg);
      }

    }
    else {
      this.spinning = false;
    }
  },
  findInfo(){
    let parms = {
      id:this.parms.achieveId,
    };
    achieveRecord_api.queryOne.requestPOSTUrlParam(this,parms,res=>{
      if(res.data.flag){
        let geomList = res.data.data.geomList;
        let geom = geomList.length > 0 ? geomList[0].geom : null;
        let id = geomList.length > 0 ? geomList[0].id : null;
        this.parms.id = id;
        this.$refs.mapInfo.wkt_show(geom);
      }
      else{
        this.$message.error(res.data.msg);
      }
    })
  },
},
}
</script>

<style scoped>

</style>